import { DeleteOutlined } from '@ant-design/icons'
import { Button, Space, Switch } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import type { Customer } from '~app/graph/generated/graphql'
import SectionCard from './SectionCard'
import useCustomerAccountActions from './useCustomerAccountActions'

/*
 * Component
 */

interface Props {
  customer: Customer
}

const AccountSection = ({ customer }: Props) => {
  const { t } = useTranslation()
  const {
    showDisableCustomerModal,
    showEnableCustomerPaywallModal,
    showDisablePaywallModal,
    paywallMutationLoading,
  } = useCustomerAccountActions()

  const isCustomerPaywalled = !!customer.paywalledAt

  return (
    <SectionCard
      rows={[
        {
          content: (
            <Space>
              <Switch
                checkedChildren={t('paywallCustomer.switch.enabled')}
                unCheckedChildren={t('paywallCustomer.switch.disabled')}
                loading={paywallMutationLoading}
                checked={isCustomerPaywalled}
                onChange={() =>
                  isCustomerPaywalled
                    ? showDisablePaywallModal(customer)
                    : showEnableCustomerPaywallModal(customer)
                }
              />
              {isCustomerPaywalled && (
                <span>
                  {t('customerDetails.fields.paywalledSince', {
                    since: dayjs(customer.paywalledAt).format(
                      'DD.MM.YYYY HH:mm'
                    ),
                  })}
                </span>
              )}
            </Space>
          ),
          label: t('paywallCustomer.switch.label'),
        },
        {
          content: (
            <Button
              type="primary"
              danger
              onClick={() => showDisableCustomerModal(customer)}
              icon={<DeleteOutlined />}
            >
              {t('disableCustomer.disableAccount')}
            </Button>
          ),
          label: t('customerDetails.fields.account'),
        },
      ]}
      title={t('customerDetails.sections.account')}
    />
  )
}

export default AccountSection
